export default __webpack_public_path__ + "static/assets/7c77706d620771dcd447c3083151b93b.png";